// 路由守卫
import store from "./store";
import {xhrGet} from '@/api/api'
import router from "./router";


export default async function (to,from,next) {
    var userToken = sessionStorage.getItem("userToken")
    // 翻译语言
    if (store.state.translateData == ''){
        const translateRes = await xhrGet('/system/translate');
        store.commit("SET_TRANSLATE", translateRes.data);
    }
    // 系统配置
    const configRes = await xhrGet('/system/config');
    store.state.configData = configRes.data
    document.title = store.state.configData.site_name
    if (''+userToken == "null"){
        // 检查 Solflare 扩展是否已安装
        if (window.solflare ) {
            // 请求连接钱包
            window.solflare.connect().then(() => {
            // 获取钱包地址
            const publicKey = window.solflare.publicKey.toString();
            console.log('Solflare Wallet Address:', publicKey);
            sessionStorage.setItem('userToken', publicKey);
            }).catch((error) => {
                console.error('Failed to connect Solflare Wallet:', error);
            });
        }
        if (window.ethereum) {
            let web3 = new Web3(window.ethereum);
            await web3.eth.requestAccounts();
            const accounts = await web3.eth.getAccounts();
            sessionStorage.setItem("userToken", accounts[0]);
            userToken =  accounts[0]
            next()
        }
    }
    if(''+userToken == "null" && to.name !== 'Empty'){
        next({ name: 'Empty' });
    }else {
        next()
    }
}


